/**
 * Created by Angelika on 26.10.2017.
 */
import React from 'react';
import ReactDOM from 'react-dom';

const portalLocation = document.getElementById('portal-root');

class PortalContainer extends React.Component {

    constructor(props) {
        super(props);
        this.elem = document.createElement('div');
    }

    componentDidMount() {
        portalLocation.appendChild(this.elem);
    }

    componentWillUnmount() {
       portalLocation.removeChild(this.elem);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.elem
        );
    }
}

export default PortalContainer;


// WEBPACK FOOTER //
// ./src/components/PortalContainer.js